import { Button, DatePicker, Form, Input, Select, Space, Row, Col } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';

import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

dayjs.extend(utc);

export type UserActivityEventsFilterComponentProps = {
  activityTypes: Array<{ value: string; label: string }>;
  onSearch: (filters: any) => void;
};

const UserActivityEventsFilterComponent = (props: UserActivityEventsFilterComponentProps) => {
  const [form] = Form.useForm();

  const handleSearch = () => {
    form.validateFields().then((values) => {
      const dateRange = values.dateRange || [];
      const filters = {
        ...values,
        startDate: dateRange[0] ? dateRange[0].utc(true).startOf('day') : undefined,
        endDate: dateRange[1] ? dateRange[1].utc(true).endOf('day') : undefined,
      };
      delete filters.dateRange;
      props.onSearch(filters);
    });
  };

  const handleClear = () => {
    form.resetFields();
    props.onSearch(undefined);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      handleSearch();
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onKeyDown={handleKeyDown}
    >
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="dateRange"
            label="Date"
          >
            <RangePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="type"
            label="Type"
          >
            <Select
              placeholder="Select type"
              options={props.activityTypes}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="objectName"
            label="Object Name"
          >
            <Input placeholder="Enter object name" />
          </Form.Item>
        </Col>
      </Row>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
        <Space>
          <Button
            size='small'
            type="primary"
            ghost
            icon={<ClearOutlined />}
            onClick={handleClear}
          >
            Clear
          </Button>
          <Button
            size='small'
            type="primary"
            ghost
            icon={<SearchOutlined />}
            onClick={handleSearch}
          >
            Search
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default UserActivityEventsFilterComponent;